import React, { useReducer } from 'react';
import Context from './state/Context';
import reducer, { initialValue } from './state/reducer';

const MainNavContextProvider = (props) => {
  const { children } = props;

  return (
    <Context.Provider value={useReducer(reducer, initialValue)}>
      {children}
    </Context.Provider>
  );
};

export default MainNavContextProvider;
